import { render, staticRenderFns } from "./Prospect_Del.vue?vue&type=template&id=a13291bc&"
import script from "./Prospect_Del.vue?vue&type=script&lang=js&"
export * from "./Prospect_Del.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports